/**
 * RFQIntegrationBoundary (AJIP-16.02.007 · WS19)
 * Pure interface contract per Founder Ruling B3.
 * NO storage reads. NO RFQ component imports. NO alternative persistence.
 */
import { RFQBoundaryError } from './BuyerJourneyErrors';

const isNonEmptyString = (v) => typeof v === 'string' && v.trim().length > 0;

const validateRfqRef = (rfqRef) => {
  if (!isNonEmptyString(rfqRef)) throw new RFQBoundaryError('rfqRef must be non-empty string');
  if (rfqRef.length > 128) throw new RFQBoundaryError('rfqRef too long');
  return true;
};

// Attach an authorised RFQ reference to buyer context. Caller supplies rfqRef
// explicitly; boundary never reads storage.
const attachRfqReference = ({ buyerContext, rfqRef }) => {
  validateRfqRef(rfqRef);
  return Object.freeze({ ...(buyerContext || {}), rfqRef });
};

const BOUNDARY_NAME = 'RFQIntegrationBoundary';

export { BOUNDARY_NAME, validateRfqRef, attachRfqReference };
